import Comments from "@common-components/comments/Comments";
import QCP_ActionCards from "@common-components/qcp-cards/QCP_ActionCards";
import QCP_ImageCards from "@common-components/qcp-cards/QCP_ImageCards";
import { useFetch } from "@hooks/useQcpApi";
import QCP_API from "api/qcpApi";
import { Button, SelectBox } from "devextreme-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import notify from "devextreme/ui/notify";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { Accordion } from "devextreme-react/accordion";
import DocCards from "./DocCards";
import { useNavigate } from "react-router-dom";
import Loader from "@common-components/loader/Loader";

export default function QCP() {
  const { id } = useParams();
  const queryParams = new URLSearchParams(window.location.search);
  const batchNumFromParams = queryParams.get("batchNum");
  const boxNumFromParams = queryParams.get("boxNum");
  const navigate = useNavigate();

  const batchNum = useSelector((state) => state.overview.batchNum);
  let batch = batchNumFromParams || localStorage.getItem("batchNum");

  const getBgColor = (progress) => {
    let bgColor = "";

    switch (progress?.toLowerCase()) {
      case "completed":
        bgColor = "bg-green-300";
        break;
      case "on hold":
        bgColor = "bg-gray-300 text-gray-700";
        break;
      case "in progress":
        bgColor = "bg-yellow-300 text-gray-700";
        break;
      case "new":
        bgColor = "bg-blue-300";
        break;
      default:
        bgColor = "bg-gray-200 text-gray-700";
    }

    return bgColor;
  };

  useEffect(() => {
    if (!batch || batch === "undefined") {
      notify({
        message:
          "Please select a batch number from the overview to see results.",
        type: "error",
        displayTime: 3000,
        position: {
          my: "top right",
          at: "top right",
          of: window,
        },
      });
    }
  }, [batch]);

  const { data: boxNumbersData, isLoading: isbatchLoading } = useFetch(
    "getBoxnumbers",
    QCP_API.getBoxNumber,
    { BatchNo: batch, PageNo: 0, PageSize: 1000 }
  );

  const [selectedBox, setSelectedBox] = useState(boxNumFromParams || "");
  const [fetchKey, setFetchKey] = useState(
    `getBoxnumbersdetails-${Date.now()}`
  );

  // Only fetch if both batch and selectedBox are set
 const shouldFetchQCP = !!batch && !!selectedBox;

const { data: matchingQCPData, isLoading: qcpDataLoading } = useFetch(
  fetchKey,
  QCP_API.getBoxNumbersDetails,
  { BatchNo: batch, BoxNo: selectedBox },
  {
    enabled: shouldFetchQCP, // 👈 This is the actual guard!
  }
);

  // console.log(matchingQCPData,'dddd12')
  // Set the latest box as default when data loads
  useEffect(() => {
    console.log("boxNumbersData", boxNumbersData);
    if (!boxNumFromParams && boxNumbersData?.data?.length) {
      const reversedData = [...boxNumbersData.data].reverse(); // Reverse the data

      console.log(boxNumbersData.data, "ssss");

      const data = boxNumbersData?.data.find(
        (d) => d?.hasTestPerformed === true
      );

      if (data) {
        setSelectedBox(data?.boxNo);
      } else {
        setSelectedBox(reversedData[0].boxNo);
      }
    }
  }, [boxNumbersData, boxNumFromParams]);

  // Find matching object from qcpdata
  console.log("matchingQCPData", matchingQCPData);

  // Update accordionItems to dynamically map based on data type
  // const accordionItems = [
  //   { id: 1, title: "Test Type: Fish Intake Control", type: 1 },
  //   { id: 2, title: "Test Type: Fillet Control 100", type: 2 },
  // ];
  const allAccordionItems = [
    { id: 1, title: "Test Type: Fish Intake Control", type: 1 },
    { id: 2, title: "Test Type: Fillet Control 100", type: 2 },
  ];

  const accordionItems =
    matchingQCPData?.data?.length > 0
      ? allAccordionItems.filter((item) =>
          matchingQCPData.data.some((d) => d?.type === item.type)
        )
      : [];
  // Modify renderQcpTestContent to filter data based on type
  const renderQcpTestContent = (item) => {
    const filteredData =
      matchingQCPData?.data?.filter((data) => data?.type === item.type) || [];

    return (
      <>
        {item.type === 1 ? (
          <p>Check each box for overall quality, smell and label.</p>
        ) : (
          <p>If the temperature exceeds 2°C in average 10%.</p>
        )}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
          <div className="lg:col-span-2 flex flex-col gap-3">
            <div>
              <QCP_ActionCards data={filteredData[0]} />
            </div>

            {filteredData.length > 0 && (
              <>
                <div className="w-full flex items-center lg:mt-4 mt-0">
                  <p className="whitespace-nowrap text-xl font-medium mb-0">
                    Picture(s):
                  </p>
                  <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
                </div>
                {filteredData[0]?.images?.length > 0 ? (
                  <div>
                    <QCP_ImageCards images={filteredData[0]?.images} />
                  </div>
                ) : (
                  <div className="flex justify-center items-center">
                    <p className="no-data-text">No Data Found</p>
                  </div>
                )}

                <div className="w-full flex items-center lg:mt-4 mt-0">
                  <p className="whitespace-nowrap text-xl font-medium mb-0">
                    Attachment(s):
                  </p>
                  <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
                </div>
                {filteredData[0]?.documents?.length > 0 ? (
                  <div>
                    <DocCards doc={filteredData[0]?.documents} />
                  </div>
                ) : (
                  <div className="flex justify-center items-center">
                    <p className="no-data-text">No Data Found</p>
                  </div>
                )}
              </>
            )}
          </div>

          <div>
            <Comments comment={filteredData[0]?.comment} />
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="dx-card responsive-paddings">
      <div className="flex justify-end mb-3 me-3">
        <Button
          onClick={() => {
            navigate("/quality/fillet/qcp");
          }}
          width={120}
          text="Add QCP"
          className="w-auto"
          stylingMode="contained"
          type="default"
        />
      </div>
      {isbatchLoading || (qcpDataLoading && selectedBox) ? (
        <div className="flex justify-center items-center h-full mt-10">
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex lg:flex-row flex-col justify-between items-center lg:space-y-0 space-y-3">
            <div className="w-full lg:w-auto flex items-center justify-between space-x-4">
              <p className="font-semibold text-lg mb-0">Batch No:</p>
              <span className="font-normal">
                {batch !== "undefined" ? batch : ""}
              </span>
            </div>
            <div className="w-full lg:w-auto flex items-center justify-between space-x-4">
              <p className="font-semibold text-lg mb-0">Box No:</p>
              <span className="font-normal">{selectedBox}</span>
            </div>
            <div className="w-full lg:w-auto flex lg:flex-row flex-col lg:items-center lg:space-x-3">
              <label className="lg:mb-0">Select Box No.</label>
              <SelectBox
                dataSource={
                  boxNumbersData?.data ? [...boxNumbersData.data].reverse() : []
                }
                displayExpr="boxNo"
                valueExpr="boxNo"
                value={selectedBox}
                onValueChanged={(e) => {
                  setSelectedBox(e.value || "");
                  if (e.value) {
                    setFetchKey(`getBoxnumbersdetails-${Date.now()}`); // Trigger API call only on selection
                  }
                  // If cleared, do not trigger fetch
                }}
                placeholder="Select Box No."
                searchEnabled={true}
                showClearButton={true}
                className="lg:w-60 w-full"
              />
            </div>
          </div>
          {accordionItems.length > 0 ? (
            <Accordion
              className="mt-3"
              dataSource={accordionItems}
              collapsible={true}
              multiple={true}
              animationDuration={300}
              itemTitleRender={(item) => <span>{item.title}</span>}
              itemRender={renderQcpTestContent}
            />
          ) : (
            <div>
              <div className="flex justify-center items-center h-96">
                <p className="no-data-text">No Data Found</p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
